import React, { useState, useMemo, useEffect } from 'react';
import axios from 'axios';

// import { useNavigate } from 'react-router-dom';
import { YarnColumns } from '../components/yarn_columns' // alle Spalten zur Anzeige in der Tabelle
import MainLayout from '../layout/MainLayout'
import BasicTable from '../components/BasicTable'
import YarnNew from '../new_pages/YarnNew'
import useDeleteWithConfirmation from '../components/useDeleteWithConfirmation';
import DeleteConfirmation from '../components/DeleteConfirmation';
import { formatTimestampNow } from '../utils/functions';
import { convertCommaToDotForFloatFields, setDefaultForEmptyNumberFields, handleFocus, handleBlur, validateField } from '../utils/functions';
import IncorrectInputModalModal from '../components/IncorrectInputModal'; // Importiere die Modal-Komponente zur Ausgabe bei Fehleingaben vom User
import { url_root } from '../config'; // Importiere die Konfigurationsdaten

import '../components/ChangeInputArea.css'
import '../components/PopupDatasheet.css'


function YarnPage() {
  
  // const navigate = useNavigate();
  const access_token = window.localStorage.getItem('access_token');

  const [yarnAll, setYarnAll] = useState([]); // Zustand für yarn-Tabellendaten
  const [manufacturerOptions, setManufacturerOptions] = useState([]); // Zustand für die manufacturer-Daten
  const [institutionOptions, setInstitutionOptions] = useState([]);

  const [structureOptions, setStructureOptions] = useState([]); // Zustand für die Struktur (Aufbau)
  const [materialOptions, setMaterialOptions] = useState([]); // Zustand für die base_material-Daten
  const [coatedMaterialOptions, setCoatedMaterialOptions] = useState([]); // Zustand für die coating_material-Daten
  
  const [textileWeightUnitOptions, setTextileWeightUnitOptions] = useState([]); // Zustand für die Maße für Gewicht/Dichte (yarn_fineness)
  const [diameterUnitOptions, setDiameterUnitOptions] = useState([]); // Zustand für die Einheit des Durchmessers
  const [flexibilityUnitOptions, setFlexibilityUnitOptions] = useState([]); // Zustand für die Maße der Flexibilität
  const [selfHeatingUnitOptions, setSelfHeatingUnitOptions] = useState([]); // Zustand für die Maße der Eigenerwärmung
  const [coatingUnitOptions, setCoatingUnitOptions] = useState([]); // Zustand für die Beschichtungsmaße
  const [coatingStabilityUnitOptions, setCoatingStabilityUnitOptions] = useState([]); // Zustand für die Einheiten der Beschichtungsstabilität
  const [electricalResistivityUnitOptions, setElectricalResistivityUnitOptions] = useState([]); // Zustand für die Maße des elektr. Widerstandes
  const [maxTemperatureUnitOptions, setMaxTemperatureUnitOptions] = useState([]); // Zustand für die Temperatureinheit
  
  const [imageOptions, setImageOptions] = useState([]); // Zustand für GarnBilder 
  const [datasheetOptions, setDatasheetOptions] = useState([]); // Zustand für die Datenblaetter

  const [popupImageUrl, setPopupImageUrl] = useState(''); // für Popup Datenblatt
  const [isPopupOpen, setIsPopupOpen] = useState(false); // für Popup Datenblatt
  const [isNewPopupOpen, setIsNewPopupOpen] = useState(false); // für Popup Neuer Datensatz
  
  const [imageUrl, setImageUrl] = useState(null);
  const [copiedData, setCopiedData] = useState(null); // Zustand für kopierte Daten
  const [clickedAnyIcon, setClickedAnyIcon] = useState(false); // Zustandsvariable, um zu ueberprüfen, welches Symbol geklickt wurde

  const [newSelectedRowID, setNewSelectedRowID] = useState(null); // Zustand um neu angelegte Datensaetze in der Tabelle zu markieren

  const [currentInstitutionName, setCurrentInstitutionName] = useState('');
  const [errors, setErrors] = useState({}); // Zustand für Fehler pro Feld
  const [errorMessage, setErrorMessage] = useState("");
  const [showErrorModal, setShowErrorModal] = useState(false); // Zustand für die Anzeige des Modals

  const id_institution = window.localStorage.getItem('id_institution');
  const id_role = window.localStorage.getItem('id_role');
  // const warningThreshold = window.localStorage.getItem("warning_threshold");

  const can_create_yarn = JSON.parse(window.localStorage.getItem('can_create_yarn'));
  const can_update_yarn = JSON.parse(window.localStorage.getItem('can_update_yarn'));
  const can_delete_yarn = JSON.parse(window.localStorage.getItem('can_delete_yarn'));


  /* post-State Objekt, um Daten zu speichern, die vom Nutzer eingegeben werden */
  const [post, setPost] = useState ({
    id_yarn: '',
    name: '',
    manufacturer_name: '',
    institution_name: '',
    diameter: '',
    unit_diameter_name: '',
    yarn_fineness: '',
    unit_yarn_fineness_name: '',
    material_name: '',
    material_own: '',
    structure_name: '',
    electrical_resistivity: '',
    unit_electrical_resistivity_name: '',
    washability_cycles: '',
    uv_resistance: '',
    flexibility: '',
    unit_flexibility_name: '',
    self_heating: '',
    unit_self_heating_name: '',
    change_flexibility: '',
    material_coated_name: '',
    material_coated_own: '',
    coating_structure: '',
    coating_adhesion: '',
    unit_coating_adhesion_name: '',
    change_coating_adhesion: '',
    coating_stability: '',
    unit_coating_stability_name: '',
    max_temperature: '',
    unit_max_temperature_name: '', 
    datasheet:'',
    filename:'',
    others: '',
    all_can_read: false, // checkbox mit boolean-Wert initialisieren
    timestamp: '',
  })


  // Funktion zum Leeren der Eingabefelder
  const clearFields = () => {
    setPost({
      id_yarn: '',
      name: '',
      manufacturer_name: '',
      institution_name: '',
      diameter: '',
      unit_diameter_name: '',
      yarn_fineness: '',
      unit_yarn_fineness_name: '',
      material_name: '',
      material_own: '',
      structure_name: '',
      electrical_resistivity: '',
      unit_electrical_resistivity_name: '',
      washability_cycles: '',
      uv_resistance: '',
      flexibility: '',
      unit_flexibility_name: '',
      self_heating: '',
      unit_self_heating_name: '',
      change_flexibility: '',
      material_coated_name: '',
      material_coated_own: '',
      coating_structure: '',
      coating_adhesion: '',
      unit_coating_adhesion_name: '',
      change_coating_adhesion: '',
      coating_stability: '',
      unit_coating_stability_name: '',
      max_temperature: '',
      unit_max_temperature_name: '',     
      datasheet:'',
      filename:'',
      others: '',
      all_can_read: false, // checkbox mit boolean-Wert initialisieren
      timestamp: '',
    });
    setErrors({});
  };

  
  // useEffect wird bei jedem neuen Laden der Seite ausgefuehrt
  useEffect(() => {
    fetchYarnAll();
    fetchManufacturerOptions();
    fetchStructureOptions();
    fetchInstitutionOptions();
    fetchUnitOptions('textile_weight_unit', setTextileWeightUnitOptions);
    fetchUnitOptions('diameter_unit', setDiameterUnitOptions);
    fetchUnitOptions('flexibility_unit', setFlexibilityUnitOptions);
    fetchUnitOptions('self_heating_unit', setSelfHeatingUnitOptions);
    fetchUnitOptions('coating_unit', setCoatingUnitOptions);
    fetchUnitOptions('coating_stability_unit', setCoatingStabilityUnitOptions);
    fetchUnitOptions('electrical_resistivity_unit', setElectricalResistivityUnitOptions);
    fetchUnitOptions('max_temperature_yarn_unit', setMaxTemperatureUnitOptions);

    fetchMaterialOptions('core', setMaterialOptions);
    fetchMaterialOptions('coating', setCoatedMaterialOptions);

    fetchYarnDatasheetOptions();
    fetchYarnImageOptions();
  }, []); 


  /*useEffect(() => {
    const checkTokenExpiry = () => {
      console.log("Initializing token expiry check...");

      const expiresAt = window.localStorage.getItem("expires_at");
      if (!expiresAt) return;

      const expiryDate = new Date(expiresAt);
      const now = new Date();
      const timeLeft = expiryDate - now;

      if (timeLeft <= 0) {
        logoutUser();
      } else if (timeLeft <= parseInt(warningThreshold, 10)) { // Warnschwelle von 1 Minuten
        // Zeige Warnung
        showExpiryWarning();
      }        
    };

    const logoutUser = () => {
      console.log("Logging out user due to token expiry.");
      window.localStorage.clear(); // Bereinige gespeicherte Daten
      navigate('/'); // Weiterleitung zur Login-Seite
      
    };
  
    const showExpiryWarning = () => {
      console.log("Warning out user due to token expiry.");
      if (!window.localStorage.getItem("warned_about_expiry")) {
        alert("Ihre Sitzung läuft bald ab. Bitte speichern Sie Ihre Arbeit.");
        window.localStorage.setItem("warned_about_expiry", true); // Verhindert wiederholte Warnungen
      }
    };
   

    // Überwachung alle 5 Sekunden
    const intervalId = setInterval(checkTokenExpiry, 5 * 1000); //5 Sekunden
  
    return () => clearInterval(intervalId); // Cleanup bei unmount
  }, [navigate]); */
  

  // Anzeige der Eingabefelder unter der Tabelle zum Aendern
  const fields = [
    { name: 'name', label: 'Bezeichnung', type: 'text', validate: { required: true} },
    { name: 'manufacturer_name', label: 'Hersteller', type: 'select' },
    { name: 'diameter', label: 'Gesamtdurchmesser', type: 'text', unit: 'unit_diameter_name', validate: { float: true} },
    { name: 'yarn_fineness', label: 'Feinheit', type: 'text', unit: 'unit_yarn_fineness_name', validate: { float: true} },
    { name: 'material_name', label: 'Material', type: 'select' },
    { name: 'material_own', label: 'eigenes Material', type: 'text' },
    { name: 'material_coated_name', label: 'Oberflächenmaterial', type: 'select' },
    { name: 'material_coated_own', label: 'eigenes Oberflächenmaterial', type: 'text' },
    { name: 'structure_name', label: 'Aufbau', type: 'select' },
    { name: 'electrical_resistivity', label: 'Elektr. Widerstand', type: 'text', unit: 'unit_electrical_resistivity_name', validate: { float: true} },
    { name: 'washability_cycles', label: 'Waschbarkeit', type: 'text', validate: { integer: true} },
    { name: 'uv_resistance', label: 'UV-Beständigkeit', type: 'text' },
    { name: 'flexibility', label: 'Flexibilität', type: 'text', unit: 'unit_flexibility_name', validate: { float: true} },
    { name: 'self_heating', label: 'Eigenerwärmung bei Stromfluss', type: 'text', unit: 'unit_self_heating_name', validate: { float: true} },
    { name: 'change_flexibility', label: 'Veränderung der Flexibilität', type: 'text' },
    { name: 'coating_structure', label: 'Rauigkeit / Struktur', type: 'text' },
    { name: 'coating_adhesion', label: 'Haftung der Beschichtung', type: 'text', unit: 'unit_coating_adhesion_name', validate: { float: true} },
    { name: 'change_coating_adhesion', label: 'Veränderung der Haftung der Beschichtung', type: 'text' },
    { name: 'coating_stability', label: 'Stabilität der Beschichtung', type: 'text', unit: 'unit_coating_stability_name', validate: { float: true} },
    { name: 'max_temperature', label: 'max. zulässige Temperatur', type: 'text', unit: 'unit_max_temperature_name', validate: { float: true} },
    { name: 'datasheet', label: 'Datenblatt', type: 'select' },
    { name: 'datasheet_buttons', label: '', type: 'datasheet_button_group' },
    { name: 'filename', label: 'Bild', type: 'select' },
    { name: 'picture_buttons', label: '', type: 'picture_button_group' },
    { name: 'others', label: 'Sonstige', type: 'textarea' },
    { name: 'all_can_read', label: 'Freigabe für alle Institutionen', type: 'checkbox' },
  ];


  // Funktion, um Benutzereingaben in Formularfeldern zu verarbeiten
  const handleInput = (event) => {
    const { name, value, type, checked } = event.target;
    setPost({ ...post, [name]: type === 'checkbox' ? checked : value });
  }
  
  // Funktion zum Einfuegen der Tabellen-Daten
  const fetchYarnAll = async () => {
    try {
      const param = {
        headers: {
          'idInstitution': id_institution, 
          'idRole': id_role,
          'Authorization': `Bearer ${access_token}`
        }
      };

      const response = await axios.get(`${url_root}/get_all_knit_yarn_to_role_institution_and_readable_ext`, param);
      setYarnAll(response.data);
      return response.data.knit_yarn || []; // Rueckgabe der aktualisierten Daten
    } catch (error) {
      console.error('Error fetching data:', error);
      return [];
    }
  };


  // Funktionen für dropdown-Listen
  // Funktion zum Abrufen aller FunktionsGarnBilder zu Institution 
  const fetchYarnImageOptions = async (institution_name) => {    
    try {
      const param = {
        headers: {
          'institutionName': institution_name, 
          'Authorization': `Bearer ${access_token}`,
          'idInstitution': id_institution   
        }
      };
      const response = await axios.get(`${url_root}/get_yarn_images_from_directory_and_institution`, param);
      
      setImageOptions(response.data);
    } catch (error) {
      console.error('Fehler beim Abrufen der picture options:', error);
    }
  };

  // Funktion zum Abrufen der Institutionen-Daten
  const fetchInstitutionOptions = async () => {
    try {
      const param = {
        headers: {
            'Authorization': `Bearer ${access_token}`
        }
      };
      const response = await axios.get(`${url_root}/get_all_knit_institution`, param);
      setInstitutionOptions(response.data);
    } catch (error) {
      console.error('Fehler beim Abrufen der institution options:', error);
    }
  };

  // Funktionen für dropdown-Listen
  // Funktion zum Abrufen aller FunktionsGarnBilder zu Institution 
  const fetchYarnDatasheetOptions = async (institution_name) => {    
    try {
      const param = {
        headers: {
          'institutionName': institution_name,
          'Authorization': `Bearer ${access_token}`,
          'idInstitution': id_institution    
        }
      };
      const response = await axios.get(`${url_root}/get_yarn_datasheets_from_directory_and_institution`, param);
      setDatasheetOptions(response.data);
    } catch (error) {
      console.error('Fehler beim Abrufen der picture options:', error);
    }
  };


  // Funktion zum Abrufen aller Hersteller
  const fetchManufacturerOptions = async () => {
    try {
      const param = {
        headers: {
          'Authorization': `Bearer ${access_token}` // Korrekte Uebergabe des Tokens
        }
      };
      const response = await axios.get(`${url_root}/get_all_knit_manufacturer`, param);
      setManufacturerOptions(response.data);
    } catch (error) {
      console.error('Fehler beim Abrufen der manufacturer options:', error);
    }
  };

  // Funktion zum Abrufen aller Strukturen
  const fetchStructureOptions = async () => {
    try {
      const param = {
        headers: {
          'Authorization': `Bearer ${access_token}` // Korrekte Uebergabe des Tokens
        }
      };
      const response = await axios.get(`${url_root}/get_all_knit_structure`, param);
      setStructureOptions(response.data);
    } catch (error) {
      console.error('Fehler beim Abrufen der structureOptions:', error);
    }
  };

  // Funktion zum Abrufen der yarn_material-Daten nach material_type
  const fetchMaterialOptions = async (materialType, setMaterialTypeOptions) => {
    try {
      const param = {
        headers: {
          'materialType': materialType,
          'Authorization': `Bearer ${access_token}`       
        }
      };    
      const response = await axios.get(`${url_root}/get_all_knit_material_to_type`, param);
      setMaterialTypeOptions(response.data);
    } catch (error) {
      console.error('Fehler beim Abrufen der materialOptions:', error);
    }
  };


  // Funktion zum Abrufen und Ermitteln der Maßeinheiten nach unit_type
  const fetchUnitOptions = async (unitType, setUnitOptions) => {
    try {
      const param = {
        headers: {
          'unitType': unitType,
          'Authorization': `Bearer ${access_token}`        
        }
      };     
      const response = await axios.get(`${url_root}/get_all_knit_unit_to_type`, param);      
      setUnitOptions(response.data);
    } catch (error) {
      console.error(`Fehler beim Abrufen der ${unitType}UnitOptions:`, error);
    }
  };


  // Vermeidung von Zugriff auf Eigenschaften von null oder leeres Array
  const knitYarnExtArray = yarnAll && yarnAll.knit_yarn_ext; 

  // Verwendet das knitYarnExtArray als Daten für die Tabelle
  const data = useMemo(() => knitYarnExtArray || [], [knitYarnExtArray]);

  // Definiere den Accessor für die BasicTable
  const accessor = 'id_yarn';


  // Funktion zum Anzeigen des Bildes bei Klick auf eine Zeile in der Tabelle, wird von der BasicTable aufgerufen
  // und bei Änderungen eines Datensatzes
  const showImage = async (imageName, maschinetypeName, institutionName) => {
    try {   
      const param = {
        headers: {
          'imageName': imageName,
          'institutionName': institutionName,
          'pageType' : 'yarn',
          'Authorization': `Bearer ${access_token}`      
        },
        responseType: 'blob' // Setzt den Antworttyp auf Blob
      };     
      const response = await axios.get(`${url_root}/show_image_from_server`, param);
      const imageBlob = response.data;

      const imageObjectURL = URL.createObjectURL(imageBlob); // Blob in eine URL konvertieren  
          
      setImageUrl(imageObjectURL); // Setze den Bild-URL-Zustand
    } catch (error) {
      console.error('Institution ID konnte nicht abgerufen werden.');
    }
  }; 

  
  // Funktion zum Anzeigen des Datasheets bei Klick auf eine Zeile in der Tabelle, wird von der BasicTable aufgerufen
  const showDatasheet = async (id) => {
    try {
      const selectedRowData = data.find(row => row.id_yarn === id);
      if (selectedRowData) {
        const selectedInstitutionName = selectedRowData.institution_name;
        const datasheetName = selectedRowData.datasheet;
          
        const param = {
          headers: {
            'datasheetName': datasheetName,
            'institutionName': selectedInstitutionName,
            'pageType' : 'yarn',
            'Authorization': `Bearer ${access_token}`
          },
          responseType: 'blob' // Setzt den Antworttyp auf Blob
        };   
      
        const response = await axios.get(`${url_root}/show_datasheet_from_server`, param);
        const datasheetBlob = response.data;
        
        const datasheetObjectURL = URL.createObjectURL(datasheetBlob); // Blob in eine URL konvertieren
        
        setPopupImageUrl(datasheetObjectURL);
        clearFields();
        setClickedAnyIcon(true); // Setzt den Zustand des geklickten Symbols auf false, wenn das newPopup geschlossen wird
        setIsPopupOpen(true);
      }
    } catch (error) {
      console.error('Institution ID konnte nicht abgerufen werden.'); 
    }
     
  };


  // zum Schließen des Popups der Datenblaetter
  const closePopup = () => {
    setClickedAnyIcon(false); // Setzt den Zustand des geklickten Symbols auf false, wenn das newPopup geschlossen wird
    setIsPopupOpen(false);
  };


  // Funktion zur Übertragung des Datensatzes in die Eingabefelder zum Ändern
  const  handleButtonChange = async (id) => {
    if (!id) {
      return;
    }

    // Fehler zurücksetzen, falls vom vorigen Datensatz noch vorhanden
    setErrors({});
    
    // Datensatz der uebergebenen id_yarn ermitteln
    const changeYarnData = data.find(row => row.id_yarn === id);
    
    // Wenn kein Datensatz gefunden wird, abbrechen
    if (!changeYarnData) {
      return;
    }

    // Aktuellen Zeitstempel abrufen und formatieren
    const timestamp = formatTimestampNow();

    setPost({
      id_yarn: changeYarnData.id_yarn,
      name: changeYarnData.name || '',
      manufacturer_name: changeYarnData.manufacturer_name || '',
      institution_name: changeYarnData.institution_name || '',
      diameter: changeYarnData.diameter,
      unit_diameter_name: changeYarnData.unit_diameter_name || '',
      yarn_fineness: changeYarnData.yarn_fineness,
      unit_yarn_fineness_name: changeYarnData.unit_yarn_fineness_name || '',
      material_name: changeYarnData.material_name || '',
      material_own: changeYarnData.material_own || '',
      structure_name: changeYarnData.structure_name || '',
      electrical_resistivity: changeYarnData.electrical_resistivity,
      unit_electrical_resistivity_name: changeYarnData.unit_electrical_resistivity_name || '',
      washability_cycles: changeYarnData.washability_cycles,
      uv_resistance: changeYarnData.uv_resistance || '',
      flexibility: changeYarnData.flexibility,
      unit_flexibility_name: changeYarnData.unit_flexibility_name || '',
      self_heating: changeYarnData.self_heating,
      unit_self_heating_name: changeYarnData.unit_self_heating_name || '',
      change_flexibility: changeYarnData.change_flexibility || '',
      material_coated_name: changeYarnData.material_coated_name || '',
      material_coated_own: changeYarnData.material_coated_own || '',
      coating_structure: changeYarnData.coating_structure || '',
      coating_adhesion: changeYarnData.coating_adhesion,
      unit_coating_adhesion_name: changeYarnData.unit_coating_adhesion_name || '',
      change_coating_adhesion: changeYarnData.change_coating_adhesion || '',
      coating_stability: changeYarnData.coating_stability,
      unit_coating_stability_name: changeYarnData.unit_coating_stability_name || '',
      max_temperature: changeYarnData.max_temperature,
      unit_max_temperature_name: changeYarnData.unit_max_temperature_name || '',     
      datasheet: changeYarnData.datasheet || '',
      filename: changeYarnData.filename || '',
      others: changeYarnData.others || '',
      all_can_read: changeYarnData.all_can_read || false,
      //timestamp: timestamp || '', // aktueller timestamp
      timestamp: changeYarnData.timestamp || formatTimestampNow(),
    })

    setCurrentInstitutionName(changeYarnData.institution_name) //institution, die der angewaehlte Datensatz hat
  }; 


  // Funktion zum Aendern des Datensatzes
  const handleSave = async (id) => {
    try {
      if (id === "" || id === undefined) {
        setErrorMessage("Bitte wählen Sie ein Funktionsgarn zum Ändern aus oder legen Sie mit NEU ein neues Funktionsgarn an.");
        setShowErrorModal(true);
        return;
      }

      // Reset the errors before validation
      setErrors({});

      // Iterieren Sie durch alle Felder und validieren Sie jedes
      fields.forEach(field => {
        const value = post[field.name] || ''; // Den aktuellen Wert abrufen
        const rules = field.rules || {}; // Regel für das Feld abrufen (stellen Sie sicher, dass Ihre Felder eine `rules`-Eigenschaft haben)
        
        // Rufen Sie die Validierungsfunktion auf
        validateField(field.name, value, rules, setErrors);
      });
      
      // Überprüfung, ob es noch Fehleingaben gibt
      const hasErrors = Object.values(errors).some(error => error !== '');

      if (hasErrors) {
        // Zeige das Modal-Popup, wenn noch Fehler vorhanden sind
        setErrorMessage("Bitte korrigieren Sie die fehlerhaften Felder, bevor Sie speichern.");
        setShowErrorModal(true);
        return; // Stoppe das Speichern, bis die Fehler behoben sind
      }

      // Fehler zurücksetzen, falls alles korrekt ist
      setErrors({});

      // Erstellen einer Kopie des Datensatzes, um ihn zu bearbeiten
      const modifiedPost = { ...post };

      // Setze leere Float- und Integer-Felder auf -123
      setDefaultForEmptyNumberFields(modifiedPost, fields);
      // Konvertiere Komma in Punkt nur bei Feldern mit { float: true }
      convertCommaToDotForFloatFields(modifiedPost, fields);

      await axios.put(`${url_root}/modify_knit_yarn_to_id`, modifiedPost,
        {
          headers: {
            'Authorization': `Bearer ${access_token}` // JWT-Token als Bearer-Token übergeben
          }
        }
      );

      newSaveID(id); // Datensatz bleibt in Tabelle markiert
      
      //const imageName = response.data.filename; // Bildname ermitteln
      //const datasheetName = post.datasheet
      const imageName = post.filename; // Bildname ermitteln
      const institutionName = post.institution_name; 
     
      fetchYarnAll(); // Tabelle aktualisieren

      showImage(imageName, null, institutionName); // Bild aktualisieren
      setClickedAnyIcon(false); // Setzt den Zustand des geklickten Symbols auf false, d.h. icon wird wieder blau
      clearFields();
    } catch (error) {
      console.error('Error saving data:', error);
    }
  };

  // Funktion zum Kopieren des Datensatzes
  const handleButtonCopy = (id) => {    
    const copyYarnData = data.find(row => row.id_yarn === id);
    setCurrentInstitutionName(copyYarnData.institution_name)

    const adjustedData = { ...copyYarnData }; // Eine Kopie der Daten erstellen, um sie zu bearbeiten

    // Fuer alle Felder im Objekt pruefen, ob der Wert 0, -123 oder null ist (Wert null ist in DB, wenn id=0)
    Object.keys(adjustedData).forEach(field => {
        if (adjustedData[field] === 0 || adjustedData[field] === -123 || adjustedData[field] === null) {
            adjustedData[field] = ''; // Wert in leeren String umwandeln
        }
    });
    setCurrentInstitutionName(copyYarnData.institution_name) 
    clearFields();
    setCopiedData(adjustedData); // Angepasste Daten im Zustand speichern
  };


  // Abfrage zum Löschen Datensatz als popup in extra Komponente und use Hook ausgelagert:
  const deleteApiUrl = `${url_root}/delete_knit_yarn_to_id`;
  // benutzerdefinierter Hook useDeleteWithConfirmation kapselt die Loeschlogik und den Zustand des Bestaetigungs-Popups
  const {
    isDeletePopupOpen,
    handleButtonDelete,
    handleConfirmDelete,
    closeDeletePopup,
  } = useDeleteWithConfirmation(deleteApiUrl, fetchYarnAll, clearFields);

  
  // Funktion zum Oeffnen des Popups für das Hinzufuegen eines neuen Eintrags
  const openNewEntryPopup = async() => {
    setClickedAnyIcon(true); // Setzt den Zustand des geklickten Symbols auf false, wenn das newPopup geschlossen wird
    setIsNewPopupOpen(true);
  };

  // Funktion zum Schliessen des Popups für neue Eintraege
  const closeNewPopup = () => {
    setCopiedData(null); // Setze copiedData auf null, Felder in YarnNew werden geleert
    setClickedAnyIcon(false); // Setzt den Zustand des geklickten Symbols auf false, wenn das newPopup geschlossen wird
    setIsNewPopupOpen(false);
    clearFields();
  };


  // Funktion zum Markieren des neuen Datensatzes in BasicTable
  const newSaveID = (id) => {
    setNewSelectedRowID(id) // newSelectedRowID wird auf den Wert der yarn_id gesetzt
  };


  // Daten aus anderen Tabellen:
  const filteredDataManufacturer = manufacturerOptions && manufacturerOptions.knit_manufacturer ? 
    manufacturerOptions.knit_manufacturer.filter(item => item.id_manufacturer !== 0) : [];
  const manufacturerOptionsSet = new Set(filteredDataManufacturer.map(item => item.name)); // Set verhindert doppelte Anzeigen bei mehrfach vorkommenden Daten
  const sortedManufacturerOptions = Array.from(manufacturerOptionsSet).sort(); // Array erstellen und aufsteigend sortieren

  const filteredDataInstitution = institutionOptions && institutionOptions.knit_institution ? institutionOptions.knit_institution.filter(item => item.id_institution !== 0) : [];
  const sortedInstitutionOptions = Array.from(new Set(filteredDataInstitution.map(item => item.name))).sort();

  const filteredDataStructure = structureOptions && structureOptions.knit_structure ? structureOptions.knit_structure.filter(item => item.id_structure !== 0) : [];
  const sortedStructureOptions = Array.from(new Set(filteredDataStructure.map(item => item.name))).sort();

  const sortedPictureOptions = imageOptions.sort(); //erscheinen in der dropdown
  
  const sortedDatasheetOptions = datasheetOptions.sort(); //erscheinen in der dropdown

  // Daten aus knit_material
  const filteredDataMaterial = materialOptions && materialOptions.knit_material_to_type ? materialOptions.knit_material_to_type.filter(item => item.id_material !== 0) : [];
  const sortedMaterialOptions = Array.from(new Set(filteredDataMaterial.map(item => item.name))).sort();

  const filteredDataCoatedMaterial = coatedMaterialOptions && coatedMaterialOptions.knit_material_to_type ? coatedMaterialOptions.knit_material_to_type.filter(item => item.id_material !== 0) : [];
  const sortedCoatedMaterialOptions = Array.from(new Set(filteredDataCoatedMaterial.map(item => item.name))).sort();

  // Daten aus knit_unit
  const filteredDataTextileWeightUnit = textileWeightUnitOptions && textileWeightUnitOptions.knit_unit_to_unit_type ? textileWeightUnitOptions.knit_unit_to_unit_type.filter(item => item.id_unit !== 0) : [];
  const sortedTextileWeightUnitOptions = Array.from(new Set(filteredDataTextileWeightUnit.map(item => item.name))).sort();

  const filteredDataDiameterUnit = diameterUnitOptions && diameterUnitOptions.knit_unit_to_unit_type ? diameterUnitOptions.knit_unit_to_unit_type.filter(item => item.id_unit !== 0) : [];
  const sortedDiameterUnitOptions = Array.from(new Set(filteredDataDiameterUnit.map(item => item.name))).sort();

  const filteredDataFlexibilityUnit = flexibilityUnitOptions && flexibilityUnitOptions.knit_unit_to_unit_type ? flexibilityUnitOptions.knit_unit_to_unit_type.filter(item => item.id_unit !== 0) : [];
  const sortedFlexibilityUnitOptions = Array.from(new Set(filteredDataFlexibilityUnit.map(item => item.name))).sort();

  const filteredDataSelfHeatingUnit = selfHeatingUnitOptions && selfHeatingUnitOptions.knit_unit_to_unit_type ? selfHeatingUnitOptions.knit_unit_to_unit_type.filter(item => item.id_unit !== 0) : [];
  const sortedSelfHeatingUnitOptions = Array.from(new Set(filteredDataSelfHeatingUnit.map(item => item.name))).sort();

  const filteredDataCoatingUnit = coatingUnitOptions && coatingUnitOptions.knit_unit_to_unit_type ? coatingUnitOptions.knit_unit_to_unit_type.filter(item => item.id_unit !== 0) : [];
  const sortedCoatedUnitOptions = Array.from(new Set(filteredDataCoatingUnit.map(item => item.name))).sort();

  const filteredDataCoatingStabilityUnit = coatingStabilityUnitOptions && coatingStabilityUnitOptions.knit_unit_to_unit_type ? coatingStabilityUnitOptions.knit_unit_to_unit_type.filter(item => item.id_unit !== 0) : [];
  const sortedCoatedStabilityUnitOptions = Array.from(new Set(filteredDataCoatingStabilityUnit.map(item => item.name))).sort();

  const filteredDataElectricalResistivityUnit = electricalResistivityUnitOptions && electricalResistivityUnitOptions.knit_unit_to_unit_type ? electricalResistivityUnitOptions.knit_unit_to_unit_type.filter(item => item.id_unit !== 0) : [];
  const sortedElectricalResistivityUnitOptions = Array.from(new Set(filteredDataElectricalResistivityUnit.map(item => item.name))).sort();
  
  const filteredDataMaxTemperatureUnit = maxTemperatureUnitOptions && maxTemperatureUnitOptions.knit_unit_to_unit_type ? maxTemperatureUnitOptions.knit_unit_to_unit_type.filter(item => item.id_unit !== 0) : [];
  const sortedMaxTemperatureUnitOptions = Array.from(new Set(filteredDataMaxTemperatureUnit.map(item => item.name))).sort();


  // Funktion zum Auffrischen des InstitutionName, wenn Admin (Rolle 1) den Institutionsnamen für neuen Datensatz im dropdown ändert
  const updateCurrentInstitutionName = async (selectedInstitutionName) => {
    setCurrentInstitutionName(selectedInstitutionName);
  }


  const ALLOWED_EXTENSIONS = ['png', 'jpg', 'jpeg'];

  const handleDatasheetChangeAndUpload = async (event) => {
    const file = event.target.files[0]; // Die ausgewaehlte Datei
    
    if (!file) {
        alert('Keine Datei ausgewählt');
        return;
    }
    else {
      const fileExtension = file.name.split('.').pop().toLowerCase();
    
      if (!ALLOWED_EXTENSIONS.includes(fileExtension)) {
        alert('Nur Dateien der Typen png, jpg und jpeg sind erlaubt.');
        return;
      }

      const allowedMimeTypes = ['image/png', 'image/jpeg'];
      if (!allowedMimeTypes.includes(file.type)) {
        alert('Ungültiger Dateityp!');
        return;
      }
    }

      const param = {
        headers: {
          'institutionName':  currentInstitutionName,
          'Authorization': `Bearer ${access_token}`,
          'idInstitution': id_institution
        }
      };
    
      const response = await axios.get(`${url_root}/get_knit_id_institution_to_institution_name`, param);
      // Lokale Kopie der Parameter
      const idInstitutionLocal = response.data.id_institution;  // Stelle sicher, dass dies lokal bleibt
      const objectTypeLocal = 'yarn';  // Spezifisch für Bilder
      // Neues FormData-Objekt erstellen
      const formData = new FormData();
      formData.append('image', file);
      formData.append('id_inst', idInstitutionLocal);
      formData.append('object_type', objectTypeLocal);
      
    try {
      // Datei an den Server hochladen
      await axios.post(`${url_root}/upload_datasheet`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data', // Für Datei-Upload erforderlich
          'Authorization': `Bearer ${access_token}`
        },
      });
      alert('Datei erfolgreich hochgeladen');
      
	  await fetchYarnDatasheetOptions(currentInstitutionName);
	  
    } catch (error) {
      console.error('Fehler beim Hochladen der Datei:', error);
      alert('Fehler beim Hochladen der Datei');
    }
  };


  const handlePictureChangeAndUpload = async (event) => {
    const file = event.target.files[0]; // Die ausgewaehlte Datei
   
    if (!file) {
      alert('Keine Datei ausgewählt');
      return;
    }
    else {
      const fileExtension = file.name.split('.').pop().toLowerCase();
    
      if (!ALLOWED_EXTENSIONS.includes(fileExtension)) {
        alert('Nur Dateien der Typen png, jpg und jpeg sind erlaubt.');
        return;
      }

      const allowedMimeTypes = ['image/png', 'image/jpeg'];
      if (!allowedMimeTypes.includes(file.type)) {
        alert('Ungültiger Dateityp!');
        return;
      }
    }
  
    const param = {
      headers: {
        'institutionName':  currentInstitutionName,
        'Authorization': `Bearer ${access_token}`,
        'idInstitution': id_institution
      }
    };     

    const response = await axios.get(`${url_root}/get_knit_id_institution_to_institution_name`, param);      
        
    // Lokale Kopie der Parameter   
    const idInstitutionLocal = response.data.id_institution;  // Stelle sicher, dass dies lokal bleibt
    const objectTypeLocal = 'yarn';  // Spezifisch für Bilder
        
    // Neues FormData-Objekt erstellen
    const formData = new FormData();
    formData.append('image', file);
    formData.append('id_inst', idInstitutionLocal);
    formData.append('object_type', objectTypeLocal);
    
    try {
      // Datei an den Server hochladen
      await axios.post(`${url_root}/upload_picture`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data', // Für Datei-Upload erforderlich
          'Authorization': `Bearer ${access_token}`
        },
      });
      alert('Datei erfolgreich hochgeladen');

      await fetchYarnImageOptions(currentInstitutionName);

    } catch (error) {
      console.error('Fehler beim Hochladen der Datei:', error);
      alert('Fehler beim Hochladen der Datei');
    }
  };
  

  
  return (
    <MainLayout openNewEntryPopup={openNewEntryPopup} showAllButton={false}>
      <BasicTable 
        columns={YarnColumns} 
        accessor={accessor}
        data={data} 
        handleButtonChange={handleButtonChange} 
        handleButtonCopy={handleButtonCopy}
        handleButtonDelete={handleButtonDelete}
        showDatasheet={showDatasheet}
        showImage={showImage}
        clearFields={clearFields} // Hier wird die Funktion als Prop übergeben
        newSaveID={newSelectedRowID} // Funktion zum Markieren des neuen Datensatzes in Tabelle übergeben
        isAnyIconClicked={clickedAnyIcon}
        showDatasheetIcon={true} // Datasheet icon wird in Tabelle angezeigt
        canCreate={can_create_yarn}
        canUpdate={can_update_yarn}
        canDelete={can_delete_yarn}
        fetchYarnImageOptions={fetchYarnImageOptions}
        fetchYarnDatasheetOptions={fetchYarnDatasheetOptions}
      />
      <div className='area-under-table'>
        {/* Nur anzeigen, wenn can_update true ist */}
        {can_update_yarn && (
        <div className='area-change'>
          <div className='box-title'>
            <h3>Hier können Sie die Parameter ändern:</h3>
          </div>
          
          {fields.map(field => {
            const fieldValue = post[field.name];
            // Setze den Wert auf einen leeren String, wenn er kleiner oder gleich 0 ist
            const displayValue = fieldValue < 0 ? '' : fieldValue;

          return (
            <div key={field.name} className="change-input-row">
              <label className={field.label.trim() === '' ? 'empty' : ''}>{field.label}</label>    

              <div className="input-with-unit">     
                {field.type === 'select' ? (
                <>
                  <select 
                    onChange={handleInput} 
                    name={field.name} 
                    value={displayValue}
                    onFocus={(event) => handleFocus(event, setErrors)}
                    onBlur={(event) => handleBlur(event, fields, {}, (name, value, rules) => 
                      validateField(name, value, rules, setErrors))}
                  >
                    <option value=""></option>
                    {field.name === 'manufacturer_name' && sortedManufacturerOptions.length > 0 ? (
                      sortedManufacturerOptions.map((option, index) => (              
                        <option key={index} value={option}>
                          {option}
                        </option>
                      ))
                      ) : field.name === 'material_name' && sortedMaterialOptions.length > 0 ? (
                        sortedMaterialOptions.map((option, index) => (              
                          <option key={index} value={option}>
                            {option}
                          </option>
                      ))
                      ) : field.name === 'structure_name' && sortedStructureOptions.length > 0 ? (
                        sortedStructureOptions.map((option, index) => (              
                          <option key={index} value={option}>
                            {option}
                          </option>
                      ))
                      ) : field.name === 'material_coated_name' && sortedCoatedMaterialOptions.length > 0 ? (
                        sortedCoatedMaterialOptions.map((option, index) => (              
                          <option key={index} value={option}>
                            {option}
                          </option>
                      ))
                      ) : field.name === 'datasheet' ? (sortedDatasheetOptions.length > 0 && sortedDatasheetOptions.filter(
                            option => option !== "") // Filtere leere Optionen heraus
                            .map((option, index) => (
                              <option key={index} value={option}>
                                {option}
                              </option>
                      ))
                      ) : field.name === 'filename' ? (sortedPictureOptions.length > 0 && 
                          sortedPictureOptions.filter(option => option !== "") // Filtere leere Optionen heraus
                            .map((option, index) => (
                              <option key={index} value={option}>
                                {option}
                              </option>
                      ))
                    ) : null}
                  </select>
                    {/* Fehlernachricht für das aktuelle select-Feld anzeigen */}
                    {errors[field.name] && (
                      <span className="error-message">{errors[field.name]}</span>
                    )}
                </>

                    ) : field.type === 'checkbox' ? (
                      <div className="change-input-row-checkbox">
                        <input 
                          type="checkbox"
                          name={field.name}
                          checked={post[field.name]}
                          onChange={handleInput}
                        />
                      </div>
                    ) : field.type === 'picture_button_group' ? ( 
                      <div className='button-group'>
                        <input
                          type="file"
                          id="fileInput4"
                          accept=".png, .jpg, .jpeg" // Erlaubt nur die angegebenen Dateitypen
                          style={{ display: 'none' }} // Versteckt den eigentlichen Datei-Input
                          onChange={handlePictureChangeAndUpload} // Event-Handler für Datei-Auswahl und Upload
                        />
                        <button
                          type="button"
                          className="custom-button"
                          onClick={() => document.getElementById('fileInput4').click()} // Oeffnet den Datei-Dialog
                        >
                          Bild auswählen und hochladen
                        </button>
                      </div>

                    ) : field.type === 'datasheet_button_group' ? (
                      <div className='button_group'>
                        <input
                          type="file"
                          id="fileInput3"
                          accept=".png, .jpg, .jpeg" // Erlaubt nur die angegebenen Dateitypen
                          style={{ display: 'none' }} // Versteckt den eigentlichen Datei-Input
                          onChange={handleDatasheetChangeAndUpload} // Event-Handler für Datei-Auswahl und Upload
                        />
                        <button
                          type="button"
                          className="custom-button"
                          onClick={() => document.getElementById('fileInput3').click()} // Oeffnet den Datei-Dialog
                        >
                          Datenblatt auswählen und hochladen
                        </button>
                      </div>
                  
                    ) : field.type === 'textarea' ? (
                        <textarea className='textarea'
                          name={field.name}
                          value={displayValue}
                          onChange={handleInput}
                        />
                    ) : (
                      <>
                        <input 
                          type={field.type} 
                          value={displayValue} 
                          onChange={handleInput} 
                          name={field.name} 
                          readOnly={field.name === 'name'} // Name des Garns kann nicht geändert werden (nur lesen)

                          onFocus={(event) => handleFocus(event, setErrors)}
                          onBlur={(event) => handleBlur(event, fields, {}, (name, value, rules) => 
                            validateField(name, value, rules, setErrors))}
                        />
                        {errors[field.name] && <span className="error-message">{errors[field.name]}</span>}     

                        {field.unit && (      // rendern nur, wenn field.unit einen Wert hat                    
                        <select // dropdown-Menu wird gerendert, wenn ein unit (Masseinheit) vorhanden ist
                          className="unit-dropdown"
                          name={field.unit} // Verwende field.unit direkt als name
                          value={post[field.unit]} // Verwende field.unit direkt, um den Wert aus post zu erhalten
                          onChange={handleInput} // Uebergebe handleInput-Funktion für onChange                 
                        >

                        <option value="" disabled> </option>
                        
                        {field.unit === 'unit_diameter_name' && sortedDiameterUnitOptions.length > 0 ? (
                          sortedDiameterUnitOptions.map((option, index) => (
                            <option key={index} value={option}>
                              {option}
                            </option>
                          ))
                        ) : field.unit === 'unit_yarn_fineness_name' && sortedTextileWeightUnitOptions.length > 0 ? (
                          sortedTextileWeightUnitOptions.map((option, index) => (
                            <option key={index} value={option}>
                              {option}
                            </option>
                          ))
                        ) : field.unit === 'unit_flexibility_name' && sortedFlexibilityUnitOptions.length > 0 ? (
                          sortedFlexibilityUnitOptions.map((option, index) => (
                            <option key={index} value={option}>
                              {option}
                            </option>
                          ))
                        ) : field.unit === 'unit_self_heating_name' && sortedSelfHeatingUnitOptions.length > 0 ? (
                          sortedSelfHeatingUnitOptions.map((option, index) => (
                            <option key={index} value={option}>
                              {option}
                            </option>
                          ))
                        ) : field.unit === 'unit_electrical_resistivity_name' && sortedElectricalResistivityUnitOptions.length > 0 ? (
                          sortedElectricalResistivityUnitOptions.map((option, index) => (
                            <option key={index} value={option}>
                              {option}
                            </option>
                          ))
                        ) : field.unit === 'unit_coating_adhesion_name' && sortedCoatedUnitOptions.length > 0 ? (
                          sortedCoatedUnitOptions.map((option, index) => (
                            <option key={index} value={option}>
                              {option}
                            </option>
                          ))
                        ) : field.unit === 'unit_coating_stability_name' && sortedCoatedStabilityUnitOptions.length > 0 ? (
                          sortedCoatedStabilityUnitOptions.map((option, index) => (
                            <option key={index} value={option}>
                              {option}
                            </option>
                          ))
                        ) : field.unit === 'unit_max_temperature_name' && sortedMaxTemperatureUnitOptions.length > 0 ? (
                          sortedMaxTemperatureUnitOptions.map((option, index) => (
                            <option key={index} value={option}>
                              {option}
                            </option>
                          ))
                        )  : null}
                      </select>
                    )}
                  </>
                )}
              </div>
            </div>
            );
          })}


          <div className='area-change-button'>
            <button onClick={() => clearFields()}>ABBRECHEN</button>
            <button onClick={() => handleSave(post.id_yarn)}>SPEICHERN</button>       
          </div>
        </div> /*Ende area-change*/
      )}      

        <div className='area-image'>
          {/* Anzeigen des Bildes, wenn imageUrl vorhanden ist */}
          {imageUrl && <img src={imageUrl} alt="kein Foto vorhanden" />}
        </div> {/*Ende area-image*/}
      </div> {/*Ende area-under-table*/}


      {/* für popup-Datenblatt */}
      {isPopupOpen && (
        <div className="popup-overlay">
          <div className="popup-content">
            <span onClick={closePopup} className="popup-close">
              &times;
            </span>
            <img src={popupImageUrl} alt="Kein Datenblatt vorhanden." />
          </div>
        </div>
      )}

      {/* für popup NEU */}
      {isNewPopupOpen && (
        <div className="new-popup-overlay">
          <div className="new-popup-content">
            <span onClick={closeNewPopup} className="new-popup-close">
              &times;
            </span>
            <YarnNew
              closeNewPopup={closeNewPopup}
              fields={fields} // Eingabefelder für neuen Datensatz
              sortedManufacturerOptions={sortedManufacturerOptions}
              sortedBaseMaterialOptions={sortedMaterialOptions}
              sortedStructureOptions={sortedStructureOptions}
              sortedInstitutionOptions={sortedInstitutionOptions}
              sortedCoatingMaterialOptions={sortedCoatedMaterialOptions}
              sortedDatasheetOptions={sortedDatasheetOptions}
              sortedPictureOptions={sortedPictureOptions}
              updateCurrentInstitutionName={updateCurrentInstitutionName}
              sortedTextileWeightUnitOptions={sortedTextileWeightUnitOptions}
              sortedDiameterUnitOptions={sortedDiameterUnitOptions}
              sortedFlexibilityUnitOptions={sortedFlexibilityUnitOptions}
              sortedSelfHeatingUnitOptions={sortedSelfHeatingUnitOptions}
              sortedElectricalResistivityUnitOptions={sortedElectricalResistivityUnitOptions}
              sortedMaxTemperatureUnitOptions={sortedMaxTemperatureUnitOptions}
              sortedCoatedUnitOptions={sortedCoatedUnitOptions}
              sortedCoatedStabilityUnitOptions={sortedCoatedStabilityUnitOptions}
              fetchYarnAll={fetchYarnAll}
              copiedData={copiedData} // Zustand kopierter Daten wird an YarnNew übermittelt
              newSaveID={newSaveID}
              formatTimestampNow={formatTimestampNow} // Funktion zur Ausgabe des aktuellen Zeitstempels
              convertCommaToDotForFloatFields={convertCommaToDotForFloatFields}
              setDefaultForEmptyNumberFields={setDefaultForEmptyNumberFields}
              handleFocus={handleFocus}
              handleBlur={handleBlur}
              validateField={validateField}
              setErrors={setErrors}
              errors={errors}
              setErrorMessage={setErrorMessage}
              setShowErrorModal={setShowErrorModal}
              handleDatasheetChangeAndUpload = {handleDatasheetChangeAndUpload}
              handlePictureChangeAndUpload = {handlePictureChangeAndUpload}
              fetchYarnImageOptions={fetchYarnImageOptions}
              fetchYarnDatasheetOptions={fetchYarnDatasheetOptions}
           />
          </div>
        </div>
      )}

      <DeleteConfirmation
        isOpen={isDeletePopupOpen}
        onClose={closeDeletePopup}
        onConfirm={handleConfirmDelete}
      />

      {/* Modal zur Fehlermeldung anzeigen, wenn showErrorModal true ist */}
      {showErrorModal && (
        <IncorrectInputModalModal
          message={errorMessage} // Dynamische Nachricht übergeben
          onClose={() => setShowErrorModal(false)} // Schließt das Modal
        />
      )}

    </MainLayout>
  );
}

export default YarnPage
